import { api } from '../core';
import { MEDICAL_MATCH_LIVE_PROCESSING_TAG } from '../constants';

export interface LiveProcessingQuestion {
  questionId: string;
  question: string;
  createdAt: string;
  /**
   * Set once a question has sat in PROCESSING past the backend's timeout, which
   * means the worker died rather than that it's still thinking. Optional until
   * that change ships — absent reads the same as not stale.
   */
  isStaleInProcessing?: boolean;
}

export interface ListLiveProcessingResponse {
  questions: LiveProcessingQuestion[];
}

export interface ListLiveProcessingRequest {
  caseId: string;
  /** `false` returns the questions as the user submitted them, `true` the agent-rephrased versions. */
  isNormalised: boolean;
}

const listLiveProcessingApi = api.injectEndpoints({
  endpoints: (builder) => ({
    listLiveProcessing: builder.query<ListLiveProcessingResponse, ListLiveProcessingRequest>({
      query: ({ caseId, isNormalised }: ListLiveProcessingRequest) => ({
        url: `medical-match-custom/list-live-processing?caseId=${encodeURIComponent(caseId)}&isNormalised=${isNormalised}`,
        method: 'GET',
      }),
      providesTags: (_result, _err, { caseId }) => [{ type: MEDICAL_MATCH_LIVE_PROCESSING_TAG, id: caseId }],
      extraOptions: { maxRetries: 3 },
    }),
  }),
});

export const { useListLiveProcessingQuery } = listLiveProcessingApi;
